'use client'

import { createContext, ReactNode, useContext } from 'react'
import { Editor } from '@tiptap/react'

type EditorContextType = {
  editor: Editor
  sourceMode: boolean
}

const EditorContext = createContext<EditorContextType | null>(null)

export const useEditorContext = () => {
  const context = useContext(EditorContext)
  if (!context) {
    throw new Error('useEditorContext must be used within <EditorProvider>')
  }
  return context
}

type PropsType = {
  editor: Editor
  sourceMode: boolean
  children: ReactNode
}

export const EditorProvider = ({ editor, sourceMode, children }: PropsType) => {
  return <EditorContext.Provider value={{ editor, sourceMode }}>{children}</EditorContext.Provider>
}
